import React from 'react';
import classNames from 'classnames';

import './styles.scss';

const Button = (props: IButton) => {
  const {
    value,
    onClick,
    loading,
    display,
    isLink,
    size,
    color,
    transparent,
    svgIcon,
    addClass,
    isResponsive,
    isDisabled,
    autoFocus,
    goToUrl,
    centered
  } = props;
  const componentClass = classNames(
    'component-button',
    `component-button--${size}`,
    `component-button--${color}`,
    `component-button--${display}`,
    addClass,
    {
      'component-button--link': isLink, // The link style is kinda special as it affects both size and color
      'component-button--loading': loading,
      'component-button--responsive': isResponsive,
      'component-button--disabled': isDisabled
    }
  );

  const buttonClass = classNames('component-button__button', {
    'component-button__button--transparent': transparent,
    'component-button--link-button': goToUrl,
    'component-button--link-centered': centered
  });

  const svgIconAvailable = <div className="component-button__button__icon">{svgIcon}</div>;
  
  return (
    <div className={componentClass}>
      {goToUrl ? (
        <a href={goToUrl} className={buttonClass}>
          {value}
          {svgIcon && svgIconAvailable}
        </a>
      ) : (
        <button
          disabled={isDisabled}
          className={buttonClass}
          aria-busy={loading}
          onClick={onClick}
          autoFocus={autoFocus}
        >
          {value}
          {svgIcon && svgIconAvailable}
        </button>
      )}
    </div>
  );
};

interface IButton {
  value: string;
  onClick?: () => void;
  display?: 'block' | 'inline' | 'block-centered';
  addClass?: string;
  loading?: boolean;
  size?: 'large' | 'small';
  color?: 'primary' | 'light' | 'light-bordered' | 'default-light';
  transparent?: boolean;
  isLink?: boolean;
  svgIcon?: React.ReactNode;
  isResponsive?: boolean; // Only implemented for large buttons
  isDisabled?: boolean;
  autoFocus?: boolean;
  goToUrl?: string;
  centered?: boolean;
}

Button.defaultProps = {
  display: 'block',
  size: 'large',
  color: 'primary'
};

export default Button;
